export function defaultGetInitials(name = '') {
	const [first = '', last = ''] = name.split(' ')

	return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase()
}
